/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Nav_Badge_LoansInputs */



/**
* | output |
* | --- |
* | "{count} loans need your confirmation" |
*
* @param {Nav_Badge_LoansInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_badge_loans = /** @type {((inputs: Nav_Badge_LoansInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Badge_LoansInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Verleihvorgänge brauchen deine Bestätigung`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} prêts attendent votre confirmation`)
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ (`${i?.count} 笔借出等待你确认`)
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ (`有 ${i?.count} 筆借卡等你確認`)
	if (locale === "ko") return /** @type {LocalizedString} */ (`확인이 필요한 대여 ${i?.count}건`)
	return /** @type {LocalizedString} */ (`${i?.count} loans need your confirmation`)
});